<script lang="ts">
  export let invalid = false
  /** The value of the `for` attribute must be a single id for a labelable form-related element. */
  export let htmlFor: string | undefined = undefined
</script>

<label class="field-label" class:invalid for={htmlFor}>
  <slot />
</label>

<style lang="scss">
  .field-label {
    font-size: var(--label-font-size);
    color: var(--color-on-background);
    opacity: 0.87;
  }

  .invalid {
    color: var(--color-error);
  }
</style>
